import React from "react"
import { useSpring, animated } from "react-spring"

export default function Accordian({ isOpen, children }) {
  const props = useSpring({
    height: isOpen ? "auto" : 0,
    overflow: "hidden",
    opacity: isOpen ? 1 : 0,
  })

  return (
    <div className="accordianwrap">
      <animated.div style={props}>{children}</animated.div>
    </div>
  )
}
